export default __webpack_public_path__ + "static/SEO_academy-7b665b54e140609dbc10ed2cc89fc46f.jpg";